import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, actionEditColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P411List({ dataTable,searchWord, contractNoS }) {
    const history = useHistory();

    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    // const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyEdit = (data) => {
        history.push({
            pathname: "412",
            state: { dataShr: { contractNo: data.contractNo, action: "EDIT", searchWord, contractNoS } },
        });
    };

    const actionBodyNew = () => {
        console.log(contractNoS);
        history.push({
            pathname: "412",
            state: { dataShr: { contractNo: "", action: "NEW", searchWord, contractNoS } },
        });
    };

    const headerLabel = <span className="hidden-responsive">เพิ่มรายการใหม่</span>;
    const header = (
        <div className="table-header">
            <Button className="p-button p-button-success btn-hidden-responsive" label={headerLabel} icon="pi pi-plus" onClick={() => actionBodyNew()} autoFocus />
            {/* <span className="p-input-icon-left span-responsive" >
                <i className="pi pi-search" />
                <InputText type="search" placeholder="คำค้น" 
                className="btn-responsive"
                onInput={(e) => setGlobalFilter(e.target.value)}
                />
            </span> */}
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    header={header}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column sortable field="contractNo" header="เลขที่สัญญา" body={(e) => normalColumn(e, "contractNo", "เลขที่สัญญา")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="contractType" header="ประเภทสัญญา" body={(e) => normalColumn(e, "contractType", "ประเภทสัญญา")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="contractorName" header="ชื่อบริษัทคู่สัญญา" body={(e) => normalColumn(e, "contractorName", "ชื่อบริษัทคู่สัญญา")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="contractAmount" header="วงเงินในสัญญา" body={(e) => normalColumn(e, "contractAmount", "วงเงินในสัญญา")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="contractBeginDate" header="วันเริ่มต้น" body={(e) => normalColumn(e, "contractBeginDate", "วันเริ่มต้น")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="contractEndDate" header="วันที่สิ้นสุด" body={(e) => normalColumn(e, "contractEndDate", "วันที่สิ้นสุด")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="contractDuration" header="ระยะเวลาดำเนินการ" body={(e) => normalColumn(e, "contractDuration", "ระยะเวลาดำเนินการ")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="contractStatus" header="สถานะโครงการ" body={(e) => normalColumn(e, "contractStatus", "สถานะโครงการ")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    {/* <Column sortable field="updateDt" header="วันที่-เวลาที่แก้ไข"  body={(e) => dateColumn(e, false, 'updateDt', 'วันที่-เวลาที่แก้ไข')} style={{ textAlign: 'center',width: '20%' }}   bodyStyle={bodyStyle.TXT_CENTER} /> */}
                    <Column header="แก้ไข" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>
        </div>
    );
}
